import DepartmentRoleManagement from '../../organization_structure/department_role_management';
import { Row, Col, Button, setParamsFilter, Typography, Form, Input } from '../../ui/ot'
import { useEffect, useRef } from "react";
const DepartmentPatronCategories = (
    permission_level = null, 
) => {
    const customFormItems = (fieldName) => {
        return (<Form.Item
            name={"department_language_data.0.language_culture_value"}
            hidden
        />)
    }
    return (<Row>
        <Col span={24}>
            <DepartmentRoleManagement
                departmentApi='/library/organization_structure/api/department'
                mode={'department'}
                key={'department'}
                // customFormItems={(fieldName, formValues, onValuesChange, propsCustomForm, propsOnValueChange, field, onFormFinish) => {
                //     return (
                //         <Form.Item
                //             label={"類型代號"}
                //             name={[field?.name ?? '', "categorycode"]}
                //             rules={[
                //                 {
                //                     required: true,
                //                     message: `此為必填項目`
                //                 }
                //             ]}
                //         >
                //             <Input />
                //         </Form.Item>
                //     )

                // }} //上層可加入自定義的form item 
                customColumns={[
                    {
                        title: '類型代號',
                        dataIndex: 'categorycode',
                        key: 'categorycode',
                    }
                ]} //列表編輯模式的顯示columns
                propsCardRender={() => { }} //card 模式要顯示的其他欄位
                permission_level={permission_level?.permission_level}
            />
        </Col>
    </Row>)
}
export default DepartmentPatronCategories